import { render } from "./reportWaiterBillProfitDetails.vue?vue&type=template&id=391a6a6f"
import script from "./reportWaiterBillProfitDetails.vue?vue&type=script&lang=js"
export * from "./reportWaiterBillProfitDetails.vue?vue&type=script&lang=js"

import "./reportWaiterBillProfitDetails.vue?vue&type=style&index=0&id=391a6a6f&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__